module.exports = __webpack_public_path__ + "img/success-result.97538b7f.png";